<template>
    <div style="position: relative">
        <c-card-iterator
            :items          = "filteredItems"
            :label          = "title"
            :loading        = "loading"
            :title-prefix   = "true"
            :pagination-on  = "true"
            :item-height    = "112"
            :min-height     = "topHeight"
            :filter         = "match"
            :filter-height  = "311"
            :height         = "height"
            @search         = "onSearch"
        >
            <template v-slot:filter>
                <div class="mt-4">
                    <div class="primary--text">
                        {{ $t("todo.assessment.prio.label") }}
                    </div>
                    <div>
                        <v-switch
                            v-model = "filter.prio.high"
                            :ripple = "false"
                            color="error"
                            class="mt-1"
                            hide-details
                        >
                            <template v-slot:label>
                                <div class="error prio-filter-label" />
                                <div >
                                    {{ $t("todo.assessment.prio.high") }}
                                </div>
                            </template>
                        </v-switch>
                    </div>

                    <div>
                        <v-switch
                            v-model = "filter.prio.middle"
                            :ripple = "false"
                            class="mt-1"
                            color="warning"
                            hide-details
                        >
                            <template v-slot:label>
                                <div class="warning prio-filter-label"  />
                                <div >
                                    {{ $t("todo.assessment.prio.middle") }}
                                </div>
                            </template>
                        </v-switch>
                    </div>

                    <div >
                        <v-switch
                            v-model = "filter.prio.low"
                            :ripple = "false"
                            hide-details
                            color="success"
                            class="mt-1"
                        >
                            <template v-slot:label>
                                <div class="success prio-filter-label" />
                                <div >
                                    {{ $t("todo.assessment.prio.low") }}
                                </div>
                            </template>
                        </v-switch>
                    </div>

                    <div class="mb-4">
                        <v-switch
                            v-model = "filter.prio.none"
                            :ripple = "false"
                            class="mt-1"
                            hide-details
                        >
                            <template v-slot:label>
                                <div class="lm-border prio-filter-label" />
                                <div >
                                    {{ $t("todo.assessment.prio.none") }}
                                </div>
                            </template>
                        </v-switch>
                    </div>

                    <v-divider />
                    <f-date-picker
                        label="Letzte Bearbeitung vor"
                        v-model="filter.modified"
                        class="mb-2 mt-2 w-50"
                        hide-details
                    />
                </div>
            </template>
            <template v-slot:card="{ item }">
                <p-inc-assessment-card
                    :item   = "item"
                    :result = "type"
                    @site   = "onSite"
                />
            </template>
        </c-card-iterator>

        <div v-if="(!items || items.length === 0) && !loading" class="lm-border empty-todos">
            <v-icon color="success" size="30">mdi-check-circle</v-icon>
        </div>
    </div>
</template>

<script>

import CCardIterator      from "@/modules/core/components/utils/CCardIterator.vue";
import PIncAssessmentCard from "@/modules/inc/todos/components/private/PIncAssessmentCard.vue";
import Core               from "@/modules/core/service/Core";
import Inc from "@/modules/inc/service/Inc";
import FDatePicker from "@/modules/core/components/utils/FDatePicker.vue";

export default {
    name: "PIncAssessmentIterator",

    components: {
        FDatePicker,
        PIncAssessmentCard,
        CCardIterator
    },

    props: {
        height: {

        },

        topHeight: {

        },

        customer: {

        },

        type: {

        },

        title: {

        },

        since: {

        },
        all: {

        },

        liftmanagement: {

        }
    },

    data: () => ({
        loading      : false,
        search       : null,
        filteredItems: null,
        items        : null,
        filter: {
            modified: null,
            prio: {
                high  : true,
                middle: true,
                low   : true,
                none  : true
            }

        }
    }),

    mounted () {
        this.initialize();
    },

    watch: {
        customer () {
            this.initialize();
        },

        liftmanagement () {
            this.initialize();
        }
    },

    methods: {
        onSearch (search) {
            this.search = search;
            this.doFilter();
        },

        onSite (item) {
            console.log("xxx", item.unitId)
            this.$emit("site", item.unitId)
        },

        initialize () {
            this.loading = true;
            Inc.todo.assessments(this.type, this.customer, this.all, this.liftmanagement).then (data => {
                this.items = data;
                this.doFilter();
                this.loading = false;
            })
        },

        doFilter () {
            if (!this.items) {
                return;
            }

            this.filteredItems = this.items.filter(i => this.match(i));
        },

        match (item) {
            if (!this.filter.prio.high && item.prio === 1) {
                return false;
            }

            if (!this.filter.prio.middle && item.prio === 2) {
                return false;
            }

            if (!this.filter.prio.low && item.prio === 3) {
                return false;
            }

            if (!this.filter.prio.none && !item.dateRemedyOfDefects) {
                return false;
            }

            if (this.filter.modified && this.filter.modified <= item.modifiedDate) {
                return false;
            }

            if (!this.search) {
                return true;
            }

            if (Core.filter.includes(item.elevatorNo, this.search)) {
                return true;
            }

            if (Core.filter.includes(item.street, this.search)) {
                return true;
            }

            if (Core.filter.includes(item.city, this.search)) {
                return true;
            }

            if (Core.filter.includes(item.zip, this.search)) {
                return true;
            }

            if (item.incidentId && Core.filter.startsWith(item.incidentId.toString(), this.search)) {
                return true;
            }

            return false;
        },

        dateAsString (value) {
            return Core.format.date.display(value)
        },
    }
}
</script>

<style scoped>

.prio-filter-label {
    width: 40px;
    height: 20px;
    border-radius: 4px;
    margin-right: 8px;
}

</style>